# PreLoader.vue
<template>
  <div v-if="loading" class="preloader-wrapper">
    <div class="preloader-container">
      <!-- Main Circle Container -->
      <div class="main-circle">
        <div class="inner-circle">
          <!-- Water Drop Icon -->
          <svg 
            class="water-drop"
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2"
          >
            <path d="M12 2L12 2C8 7 3 12 3 16C3 20 6 22 12 22C18 22 21 20 21 16C21 12 16 7 12 2Z" />
          </svg>
        </div>
      </div>

      <!-- Animated Wave Circles -->
      <div class="wave-circles">
        <div class="wave-dot wave-dot-1"></div>
        <div class="wave-dot wave-dot-2"></div>
        <div class="wave-dot wave-dot-3"></div>
        <div class="wave-dot wave-dot-4"></div>
      </div>

      <!-- Ripple Effect -->
      <div class="ripple-container">
        <div class="ripple ripple-1"></div>
        <div class="ripple ripple-2"></div>
      </div>

      <!-- Loading Text -->
      <div class="loading-text">Loading...</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const loading = ref(true);

onMounted(() => {
  // Simulate loading time - replace with actual loading logic
  setTimeout(() => {
    loading.value = false;
  }, 3000);
});
</script>

<style scoped>
.preloader-wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(239 246 255);
  z-index: 50;
}

.preloader-container {
  position: relative;
  width: 12rem;
  height: 12rem;
}

.main-circle {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inner-circle {
  width: 8rem;
  height: 8rem;
  border-radius: 9999px;
  background-color: #3B82F6;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  display: flex;
  align-items: center;
  justify-content: center;
}

.water-drop {
  width: 4rem;
  height: 4rem;
  color: white;
  animation: bounce 1s infinite;
}

.wave-circles {
  position: absolute;
  inset: 0;
  animation: spin 8s linear infinite;
}

.wave-dot {
  position: absolute;
  width: 1rem;
  height: 1rem;
  background-color: #60A5FA;
  border-radius: 9999px;
  animation: bounce 1s infinite;
}

.wave-dot-1 {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 100ms;
}

.wave-dot-2 {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  animation-delay: 200ms;
}

.wave-dot-3 {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 300ms;
}

.wave-dot-4 {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  animation-delay: 400ms;
}

.ripple-container {
  position: absolute;
  inset: 0;
}

.ripple {
  position: absolute;
  inset: 0;
  border: 4px solid #93C5FD;
  border-radius: 9999px;
  animation: ripple 2s linear infinite;
}

.ripple-2 {
  animation-delay: 1000ms;
}

.loading-text {
  position: absolute;
  bottom: -4rem;
  left: 50%;
  transform: translateX(-50%);
  color: #2563EB;
  font-weight: 700;
  font-size: 1.25rem;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .8;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes ripple {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>